import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useRef, useContext, useEffect } from 'react';
import { Waypoint } from 'react-waypoint';
import ddt from '@wix/da-ddt';
import { isActiveThread, updateCommentOffset } from '../../helpers';
import { scrollIntoViewWithHeader } from '../../../utils/scrollIntoViewWithHeader';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SimpleThread from '../SimpleThread';
import OffsetTrackingComment from '../../_partials/OffsetTrackingComment';
const logger = ddt.createLogger('comments');
const resetCommentOffset = ()=>updateCommentOffset();
const OffsetTrackingCommentThread = (_param)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    const threadStartRef = useRef(null);
    const isMobile = useContext(MobileContext);
    useEffect(()=>{
        const threadStart = threadStartRef.current;
        if (isActiveThread(props.commentableTypeId, props.commentableItemId) && threadStart) {
            logger.log('Scrolling to active thread');
            scrollIntoViewWithHeader(threadStart, isMobile);
        }
    }, [
        isMobile,
        props.commentableTypeId,
        props.commentableItemId
    ]);
    return /*#__PURE__*/ React.createElement(Waypoint, {
        onLeave: resetCommentOffset
    }, /*#__PURE__*/ React.createElement("div", {
        className: className,
        ref: threadStartRef
    }, /*#__PURE__*/ React.createElement(SimpleThread, _object_spread_props(_object_spread({}, props), {
        commentComponent: OffsetTrackingComment
    }))));
};
OffsetTrackingCommentThread.displayName = 'OffsetTrackingCommentThread';
export default OffsetTrackingCommentThread;

//# sourceMappingURL=OffsetTrackingCommentThread.js.map